import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Hook to check if the current user is an admin
 * Returns: { isAdmin: boolean | null, loading: boolean }
 */
export const useAdmin = () => {
    const [isAdmin, setIsAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAdminStatus = async () => {
            try {
                const token = localStorage.getItem('co_regulate_token');
                if (!token) {
                    setIsAdmin(false);
                    setLoading(false);
                    return;
                }

                const response = await fetch(`${API_URL}/api/auth/is-admin`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setIsAdmin(data.is_admin);
                } else {
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error('Error checking admin status:', error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAdminStatus();
    }, []);

    return { isAdmin, loading };
};

export default useAdmin;
